import { styled } from "@mui/system";
import {
  FaDownload,
  FaPhone,
  FaFax,
  FaSearch,
  FaRegEnvelope,
} from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import { StyledComponent } from "@emotion/styled";
import {
  Popper,
  PopperProps,
  autocompleteClasses,
  Table,
  styled as styledComponent,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

import { colors, accent, others } from "../../../styles/colors";

export const InputSearchIconUI = () => ({
  color: colors.fonts[9],
  paddingRight: ".25rem",
  fontSize: "1.4rem",
});

export const FaPhoneInputIcon = styled(FaPhone)((props) => ({
  marginRight: "0.75rem",
  color: props.theme.palette.primary && props.theme.palette.primary.main,
  fontSize: ".95rem",
}));

export const FaRegEnvelopeIcon = styled(FaRegEnvelope)(() => ({
  marginRight: "0.75rem",
  color: colors.primary.main,
  fontSize: "0.9rem",
}));

export const FaFaxIcon = styled(FaFax)((props) => ({
  marginRight: "0.75rem",
  color: props.theme.palette.primary && props.theme.palette.primary.main,
  fontSize: ".95rem",
}));

export const FaSearchIcon = styled(FaSearch)((props) => ({
  marginRight: "0.75rem",
  color: props.theme.palette.primary && props.theme.palette.primary.main,
  fontSize: ".95rem",
}));

export const FaPhoneInputDevider = () => ({
  marginRight: ".5rem",
  borderRightWidth: 0.7,
  height: "1.35rem",
});

export const ReferralRequestInputBox = () => ({
  padding: "1rem 2.2rem 0 1rem",
});

export const ReferralAddressInputBoxForZipcode = () => ({
  padding: "1rem 7rem 0 1rem",
});

export const VerticalDivider = () => ({
  height: "5rem",
  paddingRight: "1rem",
});

export const GenderInputUI = () => ({
  width: "100%",
});

export const PatientImageMain = () => ({
  backgroundColor: colors.backgrounds[2],
  borderRadius: "10px",
  padding: "1rem",
});

export const PatientImageOR = () => ({
  padding: ".25rem 0 .5rem 0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const ReferralImageMain = () => ({
  backgroundColor: "colors.backgroundColor[9]",
  borderRadius: "10px",
  padding: "1rem",
});

export const PatientImageRoot = () => ({
  padding: "0.5rem 2rem",
});

export const BrowsButtonUI = () => ({
  height: "1.65rem",
  paddingLeft: "1.1rem",
  paddingRight: "1.1rem",
});

export const FaDownloadIcon = styled(FaDownload)(() => ({
  fontSize: "1.05rem",
  color: colors.primary.main,
  cursor: "pointer",
}));

export const RiDeleteIcon = styled(RiDeleteBinLine)(() => ({
  fontSize: "1.35rem",
  color: accent.accentOrange[100],
  cursor: "pointer",
}));

export const DocumentRoot = () => ({
  margin: "1.5rem 1rem 0  0",
  borderRadius: "10px",
  backgroundColor: colors.backgroundColor[2],
});

export const ReferralDocMain = () => ({
  height: "5.063rem",
  paddingTop: "0.3rem",
});

export const ReferralDocList = () => ({
  backgroundColor: colors.backgroundColor[2],
  padding: "0 2.5rem 0.5rem 2.5rem",
  borderRadius: "0 0 0.625rem 0.625rem",
  overflowY: "scroll",
  height: "7rem",
});

export const ReferralDocumentList = () => ({
  backgroundColor: colors.backgroundColor[2],
  padding: "0 2.5rem 0.5rem 2.5rem",
  borderRadius: "0 0 0.625rem 0.625rem",
});

export const FileText = () => ({
  marginTop: "1rem",
  textAlign: "center",
});

export const spanStyle = () => ({
  color: colors.red[100],
});

export const fileName = () => ({
  width: "15rem",
  overflow: "hidden",
  whiteSpace: "nowrap",
  marginRight: "1rem",
});
export const fileNameForDoc = () => ({
  width: "12rem",
  overflow: "hidden",
  whiteSpace: "nowrap",
});

export const dragAndDropStyle = {
  minHeight: "5.1rem",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: `0.5px dashed ${colors.backgroundColor[9]}`,
  width: "40%",
  height: "100%",
};

export const acceptStyle = {
  border: `0.5px dashed ${colors.borders[8]}`,
};

export const rejectStyle = {
  border: `0.5px dashed ${colors.red[101]}`,
};

export const StyledPopper: StyledComponent<PopperProps> = styledComponent(
  Popper
)({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: "border-box",
    "& ul": {
      padding: 0,
      margin: 0,
    },
    "& .MuiAutocomplete-option": {
      padding: "unset",
      cursor: "auto",
    },
    "&::-webkit-scrollbar": {
      width: ".25rem",
      height: "0.3rem",
      paddingLeft: "2rem",
    },
    "&::-webkit-scrollbar-track": {
      width: 0.4,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: colors.black[6],
      borderRadius: 0.5,
      width: 0.3,
    },
  },
});

export const AutoCompletePaper = (width?: string) => ({
  "&.MuiAutocomplete-paper": {
    width: width || "42rem",
    height: "fit-content",
    border: `1px solid ${colors.borders[1]}`,
    marginLeft: "0rem",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
  },
});

export const AutocompleteTableHolder = () => ({
  width: "inherit",
  top: "1rem",
  borderRadius: "0.19rem",
  paddingBottom: "1rem",
});

export const AutocompleteRow = () => ({
  textTransform: "capitalize",
  paddingTop: "0.2rem",
});

export const TableMain = styled(Table)(() => ({
  "& .MuiTableCell-root": {
    borderRight: "none",
    borderLeft: "none",
    paddingLeft: "0.5rem",
    paddingRight: "0.7rem",
  },
  "& th:first-of-type": {
    borderRadius: "0.7rem 0 0 0.7rem",
    borderRight: "1rem",
  },
  "& th:last-of-type": {
    borderRadius: "0 0.7rem 0.7rem 0",
  },
}));

export const TimePickerIcon: any = styled(AccessTimeIcon)((props) => ({
  marginRight: ".25rem",
  color: props.theme.palette.primary && props.theme.palette.primary.main,
  fontSize: "1.4rem",
  marginTop: "1.35rem",
  padding: 0,
}));

export const timePickerField = () => ({
  padding: "0px 6px",
  fontSize: ".7rem",
  fontWeight: 500,
  lineHeight: 1.65,
});

export const timePickerFieldMargin = () => ({
  marginTop: "1.45rem",
});

export const timePickerSpacing = () => ({
  pr: 1.5,
});

export const PhysicianRecordHeader = () => ({
  backgroundColor: others.MainBackground[1],
  width: "100%",
  padding: "0.5rem",
  paddingLeft: "0.5rem",
  textAlign: "center",
});

export const AvailableRecords = () => ({
  height: "2rem",
  padding: "0.5rem",
  paddingLeft: "1rem",
});

export const TimepickerHourMinute = () => ({
  top: "3.4em",
});

export const TimePickerError = () => ({
  width: "100%",
});

export const SearchedResultTableHead = () => ({
  padding: "0.5rem",
  backgroundColor: colors.backgroundColor[8],
  borderBottom: 0,
  "&.MuiTableCell-root:first-of-type": {
    borderTopLeftRadius: "0.19rem",
    borderBottomLeftRadius: "0.19rem",
    paddingLeft: "1.5rem",
  },
  "&.MuiTableCell-root:last-child": {
    borderTopRightRadius: "0.19rem",
    borderBottomRightRadius: "0.19rem",
  },
});

export const ReadOnlyFieldContainer = (borderBottom?: boolean) => ({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  width: "100%",
  height: "2.624rem",
  color: colors.black[1],
  borderBottom: borderBottom ? `1px solid ${colors.borders[9]}` : "none",
});

export const ReadOnlyFieldLabel = () => ({
  position: "absolute",
  left: 0,
  top: 0,
  whiteSpace: "nowrap",
  display: "flex",
});

export const ReadOnlyFieldValue = () => ({
  marginTop: "0.8rem",
  height: "1.699rem",
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  width: "100%",
});

export const ReadOnlyFieldIcon = () => ({
  paddingRight: "0.5rem",
  marginTop: "0.3rem",
});

export const PhysicianNameCol = () => ({
  width: "100%",
  padding: "0.5rem",
  paddingLeft: "1rem",
  textAlign: "left",
  wordBreak: "break-word",
});

export const PhysicianNpiCol = () => ({
  width: "100%",
  padding: "0.5rem",
  textAlign: "center",
});

export const SelectPhysicianBtn = () => ({
  width: "100%",
  pl: "1.4rem",
  textAlign: "center",
});

export const StyledPopperCheckBoxAutocomplete: StyledComponent<PopperProps> =
  styledComponent(Popper)({
    [`& .${autocompleteClasses.listbox}`]: {
      boxSizing: "border-box",
      "& ul": {
        margin: "2rem",
      },
      "& .MuiAutocomplete-option": {
        cursor: "pointer",
      },
      "&::-webkit-scrollbar": {
        width: ".25rem",
        height: "0.3rem",
        paddingLeft: "2rem",
      },
      "&::-webkit-scrollbar-track": {
        width: 0.4,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: colors.black[6],
        borderRadius: 0.5,
        width: 0.3,
      },
    },
  });

export const NppesAutoCompletePaper = (width?: string) => ({
  "&.MuiAutocomplete-paper": {
    minWidth: width || "35vw",
    height: "fit-content",
    marginLeft: "0rem",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
  },
});
export const Asterisk = () => ({
  alignItems: "center",
  padding: "0rem 1.2rem 1rem 0.3rem ",
  display: "flex",
});

export const AddressField = () => ({
  padding: "1rem 3rem 1rem 0",
});

export const EmergencyContactContainer = () => ({
  backgroundColor: colors.backgroundColor[2],
});

export const EmergencyContactHeading = () => ({
  padding: "1.5rem 0 1rem 0",
  display: "flex",
  alignItems: "center",
});

export const DividerStyle = () => ({
  height: "0.8rem",
  border: `1px solid ${colors.borders[2]}`,
  margin: "0 0.5rem",
});

export const RadioFormHelperText = () => ({ marginLeft: "0rem" });

export const RadioFormLabelSize = () => ({ fontSize: "0.68rem" });
